import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../ts/Glob';
import ThemesListField from '../../../_common/platform/ts/ThemesListField';
import { ParameterField } from '../../../_common/platform/tsx/ParameterField';
import { useOverflowHook } from '../../../_common/platform/tsx/mixins/OverflowMixin';
import { getStyles, useResizeAndMoveHook } from '../../../_common/platform/tsx/mixins/ResizeMove';
import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';
import { config } from '../ts/config';
import { IValuesCollection } from '../../../_common/platform/ts/appTheme';

const reactGlobalClick = require('_common/platform/ts/reactGlobalClick');

const APP_SETTINGS_DEFAULT_THEME_FIELD = 'theme/default';

export function WorkspaceEdit(props: {
    name?: string;
    disableResizeMove?: boolean;
    disableOverflow?: boolean;
    glob: IGlob;
}) {
    const storeState = props.glob.WorkspaceEditStore.useSimpleStoreStateHook();
    const [invalid, setInvalid] = React.useState(false);
    //const [showMore, setShowMore] = React.useState(false);

    const containerRef = React.useRef<HTMLDivElement>(null);
    const contentRef = React.useRef<HTMLDivElement>(null);
    const headerRef = React.useRef<HTMLDivElement>(null);

    const { containerSize, initialContainerHeight, initialContentWidth, position } = useResizeAndMoveHook(
        {
            dialogName: 'WorkspaceEdit',
            draggable: true,
            resizable: true
        },
        'max',
        'auto',
        contentRef,
        headerRef
    );
    const containerHeight = useOverflowHook(props.disableOverflow, containerSize.height, containerRef, headerRef);

    const themeField = React.useMemo(() => new ThemesListField(props.glob, 'Inherit Options from Themes', [], {}), []);
    const initialTheme = React.useMemo(() => $.extend(true, {}, storeState.data.theme), []);

    const handleOnApply = (e) => {
        reactGlobalClick.trigger(e);
        reactGlobalClick.cancel();

        if (invalid) {
            return;
        }

        if (storeState.data != null) {
            props.glob.AppActions.workspaceSetTheme(storeState.id, null, storeState.data.theme);
        }

        handleOnCancel(e);
    };

    const handleOnCancel = (e) => {
        reactGlobalClick.trigger(e);
        reactGlobalClick.cancel();
        handleThemeChange(initialTheme, true);
        props.glob.mainRouter.navigate('/', { trigger: true });
    };

    const handleThemeChange = (value: IValuesCollection, invalid: boolean) => {
        storeState.data.theme = value;
        setInvalid(invalid);
        // if (invalid) {
        //     return;
        // }
        //props.glob.AppActions.workspaceSetTheme(state.id, null, value);
    };

    // const handleOnCreate = (e) => {
    //     props.glob.AppActions.workspaceShowDirSelect();
    // };

    // const handleOnSave = (e) => {
    //     if (storeState.actionLoading || storeState.id == null) {
    //         return;
    //     }

    //     props.glob.AppActions.workspaceSave(storeState.id, storeState.data, null);
    // };

    // const handleOnRemove = (e) => {
    //     props.glob.DialogActions.createDialog(
    //         'Delete workspace "' + props.name + '"',
    //         'Workspace "' + props.name + '" will be deleted. Please, confirm this action.',
    //         () => {},
    //         () => {
    //             props.glob.mainRouter.navigate('/', { trigger: true });
    //             props.glob.AppActions.workspaceRemove(storeState.id);
    //         },
    //         () => {},
    //         'confirm',
    //         {
    //             confirmTitle: null,
    //             cancelTitle: 'Delete'
    //         }
    //     );
    // };

    // const openView = (e) => {
    //     props.glob.mainRouter.navigate('/workspaces/' + storeState.id, {
    //         trigger: true
    //     });
    // };

    // const _getActionButtons = () => {
    //     const arr = [];

    //     if (storeState.id == null) {
    //         arr.push(
    //             <span key={'btn-success'} className="btn btn-success" onClick={handleOnCreate}>
    //                 {'Create'}
    //             </span>
    //         );
    //     } else {
    //         arr.push(
    //             <span key={'btn-success'} className="btn btn-success" onClick={handleOnSave}>
    //                 {'Save'}
    //             </span>
    //         );

    //         arr.push(
    //             <span key={'btn-danger'} className="btn btn-danger" onClick={handleOnRemove}>
    //                 {'Delete'}
    //             </span>
    //         );
    //     }

    //     arr.push(
    //         <span key={'btn-back'} className="btn btn-default" onClick={handleGoBack}>
    //             {'Go back'}
    //         </span>
    //     );

    //     return arr;
    // };

    const getTheme = (obj) => {
        const EditComponent = (themeField.constructor as any).EditComponent;
        const parentTheme = props.glob.SettingsStore.getAppSetting(APP_SETTINGS_DEFAULT_THEME_FIELD);

        return (
            <ParameterField key={'parameter-field'} param={themeField}>
                <EditComponent
                    value={obj}
                    parentThemes={[parentTheme, parentTheme && parentTheme._custom]}
                    levels={['workspace']}
                    glob={props.glob}
                    //enableApply={ true }
                    //eventsBus={ state.eventsBus }
                    onChange={handleThemeChange}
                />
            </ParameterField>
        );
    };

    // const toggleDetails = (e) => {
    //     setShowMore(!showMore);
    // };

    let content: React.JSX.Element | React.JSX.Element[];

    if (storeState.loading) {
        content = <ProgressBar />;
    } else {
        content = [];

        if (typeof storeState.data === 'object' && storeState.data.theme != null) {
            if (invalid) {
                content.push(
                    <div key="validation-error" className="validation-error">
                        {'Some settings are not valid'}
                    </div>
                );
            }

            content.push(getTheme(storeState.data.theme));
        }

        content.push(<pre key="editor" className="editor"></pre>);
    }

    const { modalStyle, containerStyle, contentStyle, bodyStyle } = getStyles(
        initialContainerHeight,
        initialContentWidth,
        containerSize.height,
        containerHeight,
        position,
        config.LAYOUT_TYPE === 'narrow'
    );

    return (
        <div
            key={storeState.id}
            className={'workspace-container theme-dialog popup-overflow-controled'} //+ (showMore ? ' show-more' : '')
        >
            <div className="modal fade show" style={modalStyle} role="dialog">
                <div className="modal-dialog" style={containerStyle} ref={containerRef}>
                    <div className="modal-content" style={contentStyle} ref={contentRef}>
                        <div className="modal-header" ref={headerRef}>
                            <h4 className="modal-title">{'Workspace Options'}</h4>

                            <div className="btn-group" role="group" aria-label="Save Buttons">
                                <button type="button" className="btn btn-success" onClick={handleOnApply}>
                                    {'Apply'}
                                </button>

                                <button type="button" className="btn btn-default" onClick={handleOnCancel}>
                                    {'Cancel'}
                                </button>
                            </div>
                        </div>

                        <div className="modal-body container-fluid" style={bodyStyle}>
                            {content}
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-backdrop fade show"></div>
        </div>
    );
}
